import { registerComponent } from '@gig/magic-common';
import PromotionsComponent from './promotions.vue.js';

var Promotions = registerComponent(PromotionsComponent);

export { Promotions };
